import {
  AnswerFaqSectionFieldsFragment,
  FaqSectionByIdQuery,
  FaqSectionByIdQueryVariables,
  QuestionFaqSectionFieldsFragment,
} from '../../../@types/generated';
import { FaqSectionById } from '@/clients/queries/contentful/FaqSectionById.graphql';
import { Heading } from 'components/src/typography';
import RichTextContainer from './RichTextContainer';
import { FAQFORM_ID } from '@/config/constants';
import Accordion from 'components/src/accordion';
import { Maybe } from 'graphql/jsutils/Maybe';
import { centeredMainChildGridClasses, centeredMainGridClasses } from '@/styles/grid';
import { useQuery } from '@apollo/client';

type FaqSectionProps = {
  id: string;
};

const renderQA = (
  {
    question,
    answer,
    id,
  }: {
    question?: Maybe<QuestionFaqSectionFieldsFragment>;
    answer?: Maybe<AnswerFaqSectionFieldsFragment>;
    id?: Maybe<string>;
  },
  sectionId?: Maybe<string>
) => {
  if (question && answer && id && sectionId) {
    return (
      <Accordion
        key={`qa-${sectionId}-${id}`}
        title={<RichTextContainer data={question} />}
        description={<RichTextContainer data={answer} />}
      />
    );
  }
  return null;
};

const FaqSection = ({ id }: FaqSectionProps) => {
  // TODO: Add loading handling
  const { error, data } = useQuery<FaqSectionByIdQuery, FaqSectionByIdQueryVariables>(FaqSectionById, {
    variables: { id: id },
  });

  if (error) {
    console.error(error);
    return <div className={centeredMainGridClasses} />;
  }

  return (
    <div id={FAQFORM_ID} className={centeredMainChildGridClasses}>
      <div
        className={`col-span-full col-start-1 my-64 grid items-stretch space-y-32 rounded-28 lg:col-span-8 lg:col-start-3`}
      >
        {data?.faqSection?.title && (
          <Heading variant="xs" classes="justify-self-center text-black-50">
            {data?.faqSection?.title}
          </Heading>
        )}
        <div className="grid space-y-16">
          {data?.faqSection?.id &&
            data?.faqSection?.qaCollection?.items &&
            data?.faqSection?.qaCollection.items.map((item) => {
              if (item && item.question && item.answer) {
                return renderQA(item, data?.faqSection?.id);
              }
              return null;
            })}
        </div>
      </div>
    </div>
  );
};

export default FaqSection;
